/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2021-12-27 14:42:17
 * @LastEditTime : 2022-11-17 15:04:08
 * @LastEditors  : yangxr
 * @Description  :
 * @FilePath     : \icps_fb\src\api\internetSales\chanceManagement.js
 */
import request from "@/utils/request";
export const queryPageA = "/icps/system/sign/cloudSell/salesLeads/queryPage";
export const queryPageB = "/icps/system/sign/cloudSell/salesLeads/queryPage";

/*忽略销售*/
export function ignore(data) {
  return request({
    url: "/icps/system/sign/cloudSell/salesLeads/ignore",
    method: "post",
    data,
  });
}
/*跟进记录列表*/
export function getsaleProgress(data) {
  return request({
    url: "/icps/system/sign/cloudSell/saleProgress/getSalesProgressList",
    method: "post",
    data,
  });
}
export function savesaleProgress(data) {
  return request({
    url: "/icps/system/sign/cloudSell/saleProgress/saveOrUpdate",
    method: "post",
    data,
  });
}
export function assignOrRedeploy(data) {
  return request({
    url: "/icps/system/sign/cloudSell/salesLeads/assignOrRedeploy",
    method: "post",
    data,
  });
}
/*新增工程*/
export function saveengineeringManagement(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/saveOrUpdate",
    method: "post",
    data,
  });
}
/*查看工程详情*/
export function QueryOneByid(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/QueryOneByid",
    method: "post",
    data,
  });
}
/*客户列表*/
export function queryAllByCompanyId(data) {
  return request({
    url: "/icps/system/sign/cloudsell/custommanage/queryAllByCompanyId",
    method: "post",
    data,
  });
}
/*往来协作单位*/
export function getOrganizationBytypes(params) {
  return request({
    url: "/base/system/base/organization/getOrganizationBytypes",
    method: "get",
    params,
  });
}

/*\获取匹配列表数据*/
export function queryMatchingEng(params) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/queryMatchingEng",
    method: "get",
    params,
  });
}

/*催办*/
export function press_to_do(data) {
  return request({
    url: "/icps/system/sign/cloudSell/salesLeads/press_to_do",
    method: "post",
    data,
  });
}
/*添加机会*/
export function salesLeadssave(data) {
  return request({
    url: "/icps/system/sign/cloudSell/salesLeads/save",
    method: "post",
    data,
  });
}
/*计算坐标运距*/
export function getEngineeringDistance(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/getEngineeringDistance",
    method: "post",
    data,
  });
}
/*增加更改记录 */
export function addFollowUpMession(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/addFollowUpMession",
    method: "post",
    data
  })
}
/*采纳更改记录 */
export function updateFollowUpStatus(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/updateFollowUpStatus",
    method: "post",
    data
  })
}
/*保存承接概率 */
export function UpdateFinancialCode(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/UpdateFinancialCode",
    method: "post",
    data
  })
}
